//// Authentication related actions

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const ACTIVATION_FAIL = 'ACTIVATION_FAIL';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_CONFIRM_FAIL = 'PASSWORD_RESET_CONFIRM_FAIL';
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const IS_TOKEN_SET = 'IS_TOKEN_SET';

export const MS_LOGIN_SUCCESS = 'MS_LOGIN_SUCCESS';
export const MS_LOGIN_FAIL = 'MS_LOGIN_FAIL';

export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS';
export const GOOGLE_AUTH_FAIL = 'GOOGLE_AUTH_FAIL';
export const FACEBOOK_AUTH_SUCCESS = 'FACEBOOK_AUTH_SUCCESS';
export const FACEBOOK_AUTH_FAIL = 'FACEBOOK_AUTH_FAIL';

// cms related actions

export const GET_PAGES_SUCCESS = 'GET_PAGES_SUCCESS';
export const GET_PAGES_FAIL = 'GET_PAGES_FAIL';

export const GET_ROUTES_SUCCESS = 'GET_ROUTES_SUCCESS';
export const GET_ROUTES_FAIL = 'GET_ROUTES_FAIL';

export const GET_SITE_INFO_SUCCESS = 'GET_SITE_INFO_SUCCESS';
export const GET_SITE_INFO_FAIL = 'GET_SITE_INFO_FAIL';

export const GET_LOGOS_SUCCESS = 'GET_LOGOS_SUCCESS';
export const GET_LOGOS_FAIL = 'GET_LOGOS_FAIL';

export const GET_THEMES_SUCCESS = 'GET_THEMES_SUCCESS';
export const GET_THEMES_FAIL = 'GET_THEMES_FAIL';

export const GET_SETTINGS_MENU_SUCCESS = 'GET_SETTINGS_MENU_SUCCESS';
export const GET_SETTINGS_MENU_FAIL = 'GET_SETTINGS_MENU_FAIL';

export const GET_OTHER_APPS_SUCCESS = 'GET_OTHER_APPS_SUCCESS';
export const GET_OTHER_APPS_FAIL = 'GET_OTHER_APPS_FAIL';

// snackbar related actions
export const SET_SNACKBAR = 'SET_SNACKBAR';

// User Preference related actions
export const GET_SAVED_USERPREFERENCES_SUCCESS =
  'GET_SAVED_USERPREFERENCES_SUCCESS';
export const GET_SAVED_USERPREFERENCES_FAIL = 'GET_SAVED_USERPREFERENCES_FAIL';

export const SAVE_CURRENT_USERPREFERENCES_SUCCESS =
  'SAVE_CURRENT_USERPREFERENCES_SUCCESS';
export const SAVE_CURRENT_USERPREFERENCES_FAIL =
  'SAVE_CURRENT_USERPREFERENCES_FAIL';

export const GET_CURRENT_USERPREFERENCES_SUCCESS =
  'GET_CURRENT_USERPREFERENCES_SUCCESS';
export const GET_CURRENT_USERPREFERENCES_FAIL =
  'GET_CURRENT_USERPREFERENCES_FAIL';

export const DELETE_USERPREFERENCE_SUCCESS = 'DELETE_USERPREFERENCE_SUCCESS';
export const DELETE_USERPREFERENCE_FAIL = 'DELETE_USERPREFERENCE_FAIL';

export const TOGGLE_SIDEBAR_SUCCESS = 'TOGGLE_SIDEBAR_SUCCESS';
export const TOGGLE_SIDEBAR_FAIL = 'TOGGLE_SIDEBAR_FAIL';

export const THEME_UPDATED = 'THEME_UPDATED';
export const THEME_UPDATE_FAILED = 'THEME_UPDATE_FAILED';
export const SIDEBAR_PREFERENCE_UPDATED = 'SIDEBAR_PREFERENCE_UPDATED';
export const SIDEBAR_PREFERENCE_UPDATE_FAILED =
  'SIDEBAR_PREFERENCE_UPDATE_FAILED';

export const GET_RECENT_REPORTS_SUCCESS = 'GET_RECENT_REPORTS_SUCCESS';
export const GET_RECENT_REPORTS_FAIL = 'GET_RECENT_REPORTS_FAIL';
export const SET_RECENT_REPORTS_SUCCESS = 'SET_RECENT_REPORTS_SUCCESS';
export const SET_RECENT_REPORTS_FAIL = 'SET_RECENT_REPORTS_FAIL';
export const REMOVE_RECENT_SUCCESS = 'REMOVE_RECENT_SUCCESS';
export const REMOVE_RECENT_FAIL = 'REMOVE_RECENT_FAIL';

export const ADD_RECENT_REPORT_SUCCESS = 'ADD_RECENT_REPORT_SUCCESS';
export const ADD_RECENT_REPORT_FAIL = 'ADD_RECENT_REPORT_FAIL';

export const LAYOUT_PREFERENCE_UPDATED = 'LAYOUT_PREFERENCE_UPDATED';
export const LAYOUT_PREFERENCE_UPDATE_FAILED =
  'LAYOUT_PREFERENCE_UPDATE_FAILED';

// notifications related actions
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAIL = 'GET_NOTIFICATIONS_FAIL';

export const UPDATE_NOTIFICATIONS_SUCCESS = 'UPDATE_NOTIFICATIONS_SUCCESS';
export const UPDATE_NOTIFICATIONS_FAIL = 'UPDATE_NOTIFICATIONS_FAIL';

// User Favourites Setup
export const GET_FAVOURITE_REPORTS_SUCCESS = 'GET_FAVOURITES_REPORTS_SUCCESS';
export const GET_FAVOURITE_REPORTS_FAIL = 'GET_FAVOURITES_REPORTS_FAIL';
export const SET_FAVOURITE_REPORT_SUCCESS = 'SET_FAVOURITE_REPORT_SUCCESS';
export const SET_FAVOURITE_REPORT_FAIL = 'SET_FAVOURITE_REPORT_FAIL';
export const REMOVE_FAVOURITE_REPORT_SUCCESS =
  'REMOVE_FAVOURITE_REPORT_SUCCESS';
export const REMOVE_FAVOURITE_REPORT_FAIL = 'REMOVE_FAVOURITE_REPORT_FAIL';

// user suggestions related actions

export const USER_ORG_DETAILS_LOADED_SUCCESS =
  'USER_ORG_DETAILS_LOADED_SUCCESS';
export const USER_ORG_DETAILS_LOADED_FAIL = 'USER_ORG_DETAILS_LOADED_FAIL';

export const GET_ALL_SUGGESTIONS_SUCCESS = 'GET_ALL_SUGGESTIONS_SUCCESS';
export const GET_ALL_SUGGESTIONS_FAIL = 'GET_ALL_SUGGESTIONS_FAIL';

// Master Data related actions
export const GET_ALL_CAPABILITIES_SUCCESS = 'GET_ALL_CAPABILITIES_SUCCESS';
export const GET_ALL_CAPABILITIES_FAIL = 'GET_ALL_CAPABILITIES_FAIL';

export const GET_ALL_SOLUTIONS_SUCCESS = 'GET_ALL_SOLUTIONS_SUCCESS';
export const GET_ALL_SOLUTIONS_FAIL = 'GET_ALL_SOLUTIONS_FAIL';

export const GET_ALL_REGIONS_SUCCESS = 'GET_ALL_REGIONS_SUCCESS';
export const GET_ALL_REGIONS_FAIL = 'GET_ALL_REGIONS_FAIL';

export const GET_ALL_MARKETS_SUCCESS = 'GET_ALL_MARKETS_SUCCESS';
export const GET_ALL_MARKETS_FAIL = 'GET_ALL_MARKETS_FAIL';

export const GET_ALL_SEGMENTS_SUCCESS = 'GET_ALL_SEGMENTS_SUCCESS';
export const GET_ALL_SEGMENTS_FAIL = 'GET_ALL_SEGMENTS_FAIL';

export const GET_ALL_REPORTS_SUCCESS = 'GET_ALL_REPORTS_SUCCESS';
export const GET_ALL_REPORTS_FAIL = 'GET_ALL_REPORTS_FAIL';

// Search related actions

export const SET_SEARCH = 'SET_SEARCH';
export const GET_SEARCH_RESULTS_SUCCESS = 'GET_SEARCH_RESULTS_SUCCESS';
export const GET_SEARCH_RESULTS_FAIL = 'GET_SEARCH_RESULTS_FAIL';
export const SET_AUTOCOMPLETE = 'SET_AUTOCOMPLETE';
export const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';

export const GET_SEARCHED_REPORTS_SUCCESS = 'GET_SEARCHED_REPORTS_SUCCESS';
export const GET_SEARCHED_REPORTS_FAIL = 'GET_SEARCHED_REPORTS_FAIL';
export const GET_SEARCH_SUCCESS = 'GET_SEARCH_SUCCESS';
export const GET_SEARCH_FAIL = 'GET_SEARCH_FAIL';

// reports related actions

export const GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS';
export const GET_REPORTS_FAIL = 'GET_REPORTS_FAIL';
export const LOAD_REPORTS_SUCCESS = 'LOAD_REPORTS_SUCCESS';
export const LOAD_REPORTS_FAIL = 'LOAD_REPORTS_FAIL';
export const ADD_REPORT_SUCCESS = 'ADD_REPORT_SUCCESS';
export const ADD_REPORT_FAIL = 'ADD_REPORT_FAIL';
export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAIL = 'UPDATE_REPORT_FAIL';
export const REMOVE_REPORT_SUCCESS = 'REMOVE_REPORT_SUCCESS';
export const REMOVE_REPORT_FAIL = 'REMOVE_REPORT_FAIL';
export const LOADING_REPORTS = 'LOADING_REPORTS';

export const GET_REPORT_DETAIL_SUCCESS = 'GET_REPORT_DETAIL_SUCCESS';
export const GET_REPORT_DETAIL_FAIL = 'GET_REPORT_DETAIL_FAIL';
export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_FAIL = 'DELETE_REPORT_FAIL';

// // User Interests Setup
// export const GET_INTERESTS_SUCCESS = 'GET_INTERESTS_SUCCESS'
// export const GET_INTERESTS_FAIL = 'GET_INTERESTS_FAIL'
// export const SAVE_INTERESTS_SUCCESS = 'SAVE_INTERESTS_SUCCESS'
// export const SAVE_INTERESTS_FAIL = 'SAVE_INTERESTS_FAIL'
// export const REMOVE_INTERESTS_SUCCESS = 'REMOVE_INTERESTS_SUCCESS'
// export const REMOVE_INTERESTS_FAIL = 'REMOVE_INTERESTS_FAIL'

// // User Quick Access Setup
// export const GET_QUICKACCESS_SUCCESS = 'GET_QUICKACCESS_SUCCESS'
// export const GET_QUICKACCESS_FAIL = 'GET_QUICKACCESS_FAIL'
// export const SAVE_QUICKACCESS_SUCCESS = 'SAVE_QUICKACCESS_SUCCESS'
// export const SAVE_QUICKACCESS_FAIL = 'SAVE_QUICKACCESS_FAIL'
// export const REMOVE_QUICKACCESS_SUCCESS = 'REMOVE_QUICKACCESS_SUCCESS'
// export const REMOVE_QUICKACCESS_FAIL = 'REMOVE_QUICKACCESS_FAIL'
